document.addEventListener('DOMContentLoaded', function() {
    const archiveBlocks = document.querySelectorAll('.wcl-archive-block');
    
    archiveBlocks.forEach(block => {
        const filterButtons = block.querySelectorAll('.wcl-archive-block__filter-btn');
        const cardsWrapper = block.querySelector('.wcl-archive-block__cards-wrapper');
        const loader = block.querySelector('.wcl-archive-block__loader');
        const allBtn = block.querySelector('.wcl-archive-block__filter-btn[data-category="all"]');
        
        let isLoading = false;
        
        filterButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                if (isLoading) return;
                
                const category = this.getAttribute('data-category');
                
                if (category === 'all') {
                    filterButtons.forEach(b => b.classList.remove('active'));
                    this.classList.add('active');
                } else {
                    allBtn.classList.remove('active');
                    this.classList.toggle('active');
                    
                    const activeButtons = block.querySelectorAll('.wcl-archive-block__filter-btn.active:not([data-category="all"])');
                    
                    if (activeButtons.length === 0) {
                        allBtn.classList.add('active');
                    }
                }
                
                const selectedCategories = [];
                const activeButtons = block.querySelectorAll('.wcl-archive-block__filter-btn.active:not([data-category="all"])');
                
                activeButtons.forEach(activeBtn => {
                    const catId = activeBtn.getAttribute('data-category');
                    if (catId && catId !== 'all') {
                        selectedCategories.push(parseInt(catId, 10));
                    }
                });
                
                isLoading = true;
                loader.style.display = 'flex';
                cardsWrapper.style.opacity = '0.5';
                
                const requestBody = {
                    post_type: block.getAttribute('data-post-type'),
                    taxonomy: block.getAttribute('data-taxonomy'),
                    categories: selectedCategories
                };

                fetch(config.rest_url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestBody)
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.html !== undefined) {
                        cardsWrapper.innerHTML = data.html; 
                        
                        const event = new CustomEvent('archiveFiltered', {                             
                            detail: {                                 
                                count: data.count,                         
                                categories: selectedCategories                             
                            }                         
                        });
                        block.dispatchEvent(event);
                    } else {
                        console.error('REST error: Unexpected data structure', data);
                    }
                })
                .catch(error => {
                    console.error('Fetch error:', error);
                })
                .finally(() => {
                    isLoading = false;
                    loader.style.display = 'none';
                    cardsWrapper.style.opacity = '1';
                });
            });
        });
    });
});